import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, MapPin, CheckCircle2 } from 'lucide-react';
const SERVICE_AREAS = ['Farmington Hills', 'Farmington', 'Novi', 'Commerce', 'Walled Lake', 'Wixom', 'Livonia', 'Northville', 'Waterford', 'West Bloomfield', 'Milford', 'White Lake'];
export function ContactFormDetails() {
  return <aside className="lg:col-span-2 flex flex-col gap-6" data-id="element-840">
      <div className="bg-paper border border-subtle-gray rounded-2xl p-8" data-id="element-841">
        <h3 className="text-xl text-ink mb-4 flex items-center gap-2" data-id="element-842">
          <Clock className="w-5 h-5 text-storm-red" data-id="element-843" />
          Operating Hours
        </h3>
        <div className="flex flex-col gap-2 text-gray-warm" data-id="element-844">
          <div className="flex justify-between" data-id="element-845">
            <span data-id="element-846">Monday – Friday</span>
            <span className="font-bold text-ink" data-id="element-847">4:00 PM – 8:00 PM</span>
          </div>
          <div className="flex justify-between" data-id="element-848">
            <span data-id="element-849">Saturday</span>
            <span className="font-bold text-ink" data-id="element-850">Morning / Events</span>
          </div>
          <div className="flex justify-between" data-id="element-851">
            <span data-id="element-852">Sunday</span>
            <span className="font-bold text-ink" data-id="element-853">Closed</span>
          </div>
        </div>
        <p className="text-xs text-gray-warm mt-4 pt-4 border-t border-subtle-gray" data-id="element-854">
          Hours are class-time hours. Phone messages and form submissions
          outside these hours are returned the next business day.
        </p>
      </div>

      <div className="bg-ink text-off-white rounded-2xl p-8" data-id="element-855">
        <h3 className="text-xl text-white mb-4 flex items-center gap-2" data-id="element-856">
          <MapPin className="w-5 h-5 text-storm-red" data-id="element-857" />
          Service Areas
        </h3>
        <p className="text-gray-warm text-sm mb-4 leading-relaxed" data-id="element-858">
          Storm Taekwondo serves families across Southeast Michigan, including:
        </p>
        <ul className="flex flex-wrap gap-2" data-id="element-859">
          {SERVICE_AREAS.map(area => <li key={area} className="bg-charcoal/60 border border-charcoal rounded-full px-3 py-1 text-xs font-medium" data-id="element-860">
              {area}
            </li>)}
        </ul>
      </div>

      <div className="bg-storm-red text-white rounded-2xl p-8" data-id="element-861">
        <h3 className="text-xl text-white mb-3 flex items-center gap-2" data-id="element-862">
          <CheckCircle2 className="w-5 h-5" data-id="element-863" />
          Ready to start?
        </h3>
        <p className="text-white/90 mb-4 leading-relaxed" data-id="element-864">
          Looking to book a trial class instead of asking a question?
        </p>
        <Link to="/SignMeUp" className="inline-block bg-white text-ink font-bold py-3 px-6 rounded-xl hover:bg-off-white transition-colors" data-id="element-865">
          Start With a Trial Class →
        </Link>
      </div>
    </aside>;
}